
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';

import Zodiac from '../../../components/ZodiacSign/Zodiac';
import EkadashiCal from '../../../components/EkadashiCalender/ekadashiCal';
import './ekadashi.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import { useState } from "react";




const Ekadashi = () => {

const [popupDeity, setPopupDeity] = useState(null);
const [selectedEkadashi, setSelectedEkadashi] = useState(null);


  const deities = {
  lordVishnu: {
    name: "Lord Vishnu",
    significance: "Lord Vishnu is regarded as the preserver and protector of the universe in Hinduism. He is part of the Holy Trinity (Trimurti) along with Brahma and Shiva.",
    mythology: "According to Hindu scriptures, Lord Vishnu incarnates on Earth whenever there is a decline in Dharma (righteousness) to restore cosmic order. His ten principal avatars (Dashavatara) include Rama, Krishna, Narasimha, and Vamana.",
    symbols: [
      "Conch (Shankha) – representing the cosmic sound Om",
      "Discus (Chakra) – symbolizing the mind and cosmic order",
      "Lotus (Padma) – purity and spiritual liberation",
      "Mace (Gada) – power and authority"
    ],
    culturalAspect: "Lord Vishnu is worshipped by millions across the world, especially in Vaishnavism traditions. His temples, rituals, and festivals like Janmashtami, Ram Navami, and Vaikuntha Ekadashi are widely observed."
  }
};



  return (
    <div className="ekadashi-container">
      <InnerNav />
      <div className="ekadashi-content">
        <Zodiac />

{!selectedEkadashi ? (
  <>
    <EkadashiCal onSelectEkadashi={setSelectedEkadashi} />

    <section className="ekadashi-wrapper">
      <h1 className="ekadashi-title">Ekadashi Fasting Days</h1>
      <div className="ekadashi-texts">
        <p>
          Ekadashi fasting is observed on every 11th Tithi in Hindu calendar. There are two Ekadashi fasting in a month, one during Shukla Paksha and another during Krishna Paksha. Devotees of 
            <span className="popup-link" onClick={() => setPopupDeity('lordVishnu')}> Lord Vishnu</span>  
          observe Ekadashi fasting to seek His blessings.
        </p>

        <p>
          Ekadashi fasting spans for three days. Devotees take single meal in the afternoon a day before fasting day to make sure there is no residual food in the stomach on next day. Devotees keep strict fast on Ekadashi day and break the fast on next day only after sunrise. Eating of all type of grains and cereals is prohibited during Ekadashi fasting.
        </p>

        <p>
          Devotees can choose to observe fasting without water, with only water, with only fruits, with one time latex food according to their will and body power. However it should be decided before starting the fast.
        </p>

        <h2>Ekadashi Vrat</h2>
        <p>
          At times Ekadashi fasting is suggested on two consecutive days. It is advised that Smartha with family should observe fasting on first day only. The alternate Ekadashi fasting, which is the second one, is suggested for Sanyasis, widows and for those who want Moksha. When alternate Ekadashi fasting is suggested for Smartha it coincides with Vaishnava Ekadashi fasting day.
        </p>

        <p>
          Ekadashi fasting on both days is suggested for staunch devotees who seek for love and affection of Lord Vishnu.
        </p>

        <p>
          This page lists Ekadashi fasting days for Smarthas. Vaishnavas should check Vaishnava Ekadashi Fasting to know Vaishnava fasting days. Vaishnava fasting day might be one day after of Smartha fasting day.
        </p>
      </div>
    </section>
       <VratLinks />
  </>
) : (
<div className="ekadashi-detail-view">
  <button
    className="back-btn"
    onClick={() => setSelectedEkadashi(null)}
  >
    ← Back
  </button>

  <div className="ekadashi-report-card">
    <img
      src={selectedEkadashi.image || "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg"}
      alt={selectedEkadashi.ekadashiName}
      className="ekadashi-report-image"
    />

    <div className="ekadashi-report-content">
      <h1>{selectedEkadashi.ekadashiName}</h1>

      <p><strong>Date:</strong> {selectedEkadashi.date}</p>
      <p><strong>Day:</strong> {selectedEkadashi.day}</p>
      <p><strong>Paksha:</strong> {selectedEkadashi.paksha}</p>
      <p><strong>Tithi:</strong> {selectedEkadashi.tithiName}</p>

      <hr />

      <p><strong>Tithi Begins:</strong> {selectedEkadashi.tithiStart}</p>
      <p><strong>Tithi Ends:</strong> {selectedEkadashi.tithiEnd}</p>

      <p><strong>Lunar Details:</strong> {selectedEkadashi.lunarDetail}</p>
    </div>
  </div>
</div>

)}
        {/* <CommentBox/> */}
      </div>
      <Footer />
      {popupDeity && (
  <div className="popup-overlay" onClick={() => setPopupDeity(null)}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <h2>{deities[popupDeity].name}</h2>
      <p><strong>Significance:</strong> {deities[popupDeity].significance}</p>
      <p><strong>Mythology:</strong> {deities[popupDeity].mythology}</p>

      <h3>Symbols</h3>
      <ul>
        {deities[popupDeity].symbols.map((symbol, idx) => (
          <li key={idx}>{symbol}</li>
        ))}
      </ul>

      <p><strong>Cultural Aspect:</strong> {deities[popupDeity].culturalAspect}</p>

      <button className="close-btn" onClick={() => setPopupDeity(null)}>Close</button>
    </div>
  </div>
)}

    </div>
  );
};

export default Ekadashi;
